import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Service from '../../config/networkutils';
import { getCookie } from '../../utils/CookieHelper';
import { Box, CircularProgress } from '@material-ui/core';
import { withSnackbar } from 'notistack';

const token = getCookie("ptd_ts_token");

const styles = (theme) => ({
    root: {
        margin: 'auto',
    },
    paper: {
        width: 200,
        height: 230,
        overflow: 'auto',
    },
    button: {
        margin: theme.spacing(0.5, 0),
    },
});

function not(a, b) {
    return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
    return a.filter((value) => b.indexOf(value) !== -1);
}

const gateStageOptions = ['secured', 'unsecured', 'completed']

class GateStageLink extends Component {
    state = {
        checked: [],
        left: [],
        right: [],
        isLoading: true
    };

    handleToggle = (value) => () => {
        const { checked } = this.state;
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        this.setState({ checked: newChecked });
    };

    handleAllRight = () => {
        const { left, right } = this.state;
        this.setState({
            right: right.concat(left),
            left: [],
        });
    };

    handleCheckedRight = () => {
        const { checked, left, right } = this.state;
        const leftChecked = intersection(checked, left);

        this.setState({
            right: right.concat(leftChecked),
            left: not(left, leftChecked),
            checked: not(checked, leftChecked),
        }, () => {
            this.linkDelinkGateStage('link', leftChecked)
        })
    };

    linkDelinkGateStage = (action, items) => {
        this.setState({ isLoading: true });
        let data = {
            key: items.map((item) => item.value)[0],
            action: action
        }
        if (this.props.gateStage) {
            data['gate_stage'] = this.props.stage.id
        }
        if (this.props.salesStage) {
            data['sales_stage'] = this.props.stage.id
        }
        Service.patch(this.props.post_api, {
            headers: {
                Authorization: "Token " + token,
            },
            data: data
        })
            .then(res => {
                this.getData()
                let message = ''
                if (action === 'link') {
                    message = 'Gate stage linked successfully'
                } else {
                    message = 'Gate stage delinked successfully'
                }
                this.props.enqueueSnackbar(message, {
                    variant: 'success'
                });
            })
            .catch(error => {
                if (error.status === 403) {
                    this.props.enqueueSnackbar(error.data.message + ' for ' + this.props.tableName, {
                        variant: 'warning'
                    })
                } else {
                    this.props.enqueueSnackbar('Unable to fetch ' + this.props.tableName + " data", {
                        variant: 'error'
                    });
                }
                this.setState({ isLoading: false });
            })
    }

    handleCheckedLeft = () => {
        const { checked, left, right } = this.state;
        const rightChecked = intersection(checked, right);

        this.setState({
            left: left.concat(rightChecked),
            right: not(right, rightChecked),
            checked: not(checked, rightChecked),
        }, () => {
            this.linkDelinkGateStage('delink', rightChecked)
        });
    };

    handleAllLeft = () => {
        const { left, right } = this.state;
        this.setState({
            left: left.concat(right),
            right: [],
        });
    };

    customList = (items) => {
        const { classes } = this.props;
        const { checked } = this.state;

        return (
            <Paper className={classes.paper}>
                <List dense component="div" role="list">
                    {items.map((value) => {
                        const labelId = `transfer-list-item-${value}-label`;

                        return (
                            <ListItem key={value} role="listitem" button onClick={this.handleToggle(value)}>
                                <ListItemIcon>
                                    <Checkbox
                                        checked={checked.indexOf(value) !== -1}
                                        tabIndex={-1}
                                        disableRipple
                                        inputProps={{ 'aria-labelledby': labelId }}
                                    />
                                </ListItemIcon>
                                <ListItemText id={labelId} primary={value.name} />
                            </ListItem>
                        );
                    })}
                    <ListItem />
                </List>
            </Paper>
        );
    };

    getData() {
        this.setState({ isLoading: true })
        Service.get(`${this.props.get_api}${this.props.stage.id}`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                const linkedValues = Array.isArray(res.data)
                    ? res.data
                    : Array.isArray(res.data?.keys)
                        ? res.data.keys
                        : [];

                const normalizedLinkedValues = linkedValues
                    .map((item) => {
                        if (typeof item === 'string') {
                            return item;
                        }

                        return item?.value || item?.key || item?.name;
                    })
                    .filter(Boolean);

                const left = [];
                const right = [];

                gateStageOptions.forEach((element) => {
                    const item = {
                        name: element[0].toUpperCase() + element.slice(1),
                        value: element,
                    };

                    if (normalizedLinkedValues.includes(element)) {
                        right.push(item);
                    } else {
                        left.push(item);
                    }
                });

                this.setState({
                    left,
                    right,
                    checked: [],
                })
            })
            .catch(error => {
                if (error.status === 403) {
                    this.props.enqueueSnackbar(error.data.message, {
                        variant: 'warning'
                    })
                } else {
                    this.props.enqueueSnackbar('Unable to fetch ' + this.props.tableName + " data", {
                        variant: 'error'
                    });
                }
            })
            .finally(() => { this.setState({ isLoading: false }) });

    }

    componentDidMount() {
        this.getData()
    }

    render() {
        const { classes } = this.props;
        const { checked, left, right } = this.state;
        const leftChecked = intersection(checked, left);
        const rightChecked = intersection(checked, right);

        return (
            <div>
                {this.state.isLoading ? <Box display="flex" justifyContent="center" alignItems="center" width='100%'><CircularProgress /></Box> :
                    <Grid
                        container
                        spacing={2}
                        justifyContent="center"
                        alignItems="center"
                        className={classes.root}
                    >
                        <Grid item>{this.customList(left)}</Grid>
                        <Grid item>
                            <Grid container direction="column" alignItems="center">
                                {/* <Button
                            variant="outlined"
                            size="small"
                            className={classes.button}
                            onClick={this.handleAllRight}
                            disabled={left.length === 0}
                            aria-label="move all right"
                        >
                            ≫
                        </Button> */}
                                <Button
                                    variant="outlined"
                                    size="small"
                                    className={classes.button}
                                    onClick={this.handleCheckedRight}
                                    disabled={leftChecked.length === 0}
                                    aria-label="move selected right"
                                >
                                    &gt;
                                </Button>
                                <Button
                                    variant="outlined"
                                    size="small"
                                    className={classes.button}
                                    onClick={this.handleCheckedLeft}
                                    disabled={rightChecked.length === 0}
                                    aria-label="move selected left"
                                >
                                    &lt;
                                </Button>
                                {/* <Button
                            variant="outlined"
                            size="small"
                            className={classes.button}
                            onClick={this.handleAllLeft}
                            disabled={right.length === 0}
                            aria-label="move all left"
                        >
                            ≪
                        </Button> */}
                            </Grid>
                        </Grid>
                        <Grid item>{this.customList(right)}</Grid>
                    </Grid>}
            </div>
        );
    }
}

export default withSnackbar(withStyles(styles)(GateStageLink));

